import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { CancellationEndpoint } from '@acorn-portal/shared/src/pages/cancellation/types';
import { useCancellationAccessConfig } from '@acorn-portal/shared/src/pages/policy/hooks/journey-access/cancellation/use-cancellation-access-config';
import { getUrlSuffix } from '@acorn-portal/shared/src/utils/get-url-suffix';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { validateStep } from './validate-step';

type StepPermissionHelpers = {
	stepPermitted: boolean;
};

/**
 * Custom hook to determine if the current step in the cancellation process is permitted
 * @returns {StepPermissionHelpers} - Whether the current step is permitted
 */
export const useStepPermission = (): StepPermissionHelpers => {
	const location = useLocation();
	const cancellationState = useAppSelector((state) => state.cancellation);
	const accessConfig = useCancellationAccessConfig();
	const journeyPermitted = !!accessConfig?.fullAccess;
	const [stepPermitted, setStepPermitted] = useState<boolean>(journeyPermitted); // journeyPermitted establishes a starting point
	const currentUrl = location.pathname;

	// Route guard checks
	useEffect(() => {
		// Basic checks
		if (!journeyPermitted) return;
		// URL validation against cancellationState
		const urlSuffix = getUrlSuffix(currentUrl) as CancellationEndpoint;
		const permittedStep = validateStep(urlSuffix, cancellationState.stepCeiling, cancellationState.takenUp);
		setStepPermitted(permittedStep);
	}, [location]);

	return { stepPermitted };
};
